module.exports = __webpack_public_path__ + "static/slogan-brown-2be9192eeea11ef99f59b9a7f799f4d1.png";